import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import LeadTimeLabel from '../../quotes/lead-times/LeadTimeLabel';
import { QuoteProductDto } from '../../quotes/otherQuoteEntities';
import { LeadTimeComponentOutput } from '../../quotes/quoteProductLeadTimeService';
import LeadTimeOverrideCalculationService from '../review/quote-products/LeadTimeOverrideCalculationService';
import LeadTimeOverrideModal from '../review/quote-products/LeadTimeOverrideModal';
import { isAmiUserAuthorizedToOverrideQuoteLeadTimes } from '@ami/react/shared';

export default class LeadTimeComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.leadTimeOverrideModal = React.createRef();

    this.state = {
    };
  }

  static propTypes = {
    name: PropTypes.string.isRequired,
    leadTimeItem: PropTypes.instanceOf(LeadTimeComponentOutput).isRequired,
    quoteProduct: PropTypes.instanceOf(QuoteProductDto).isRequired,
    isOverrideMode: PropTypes.bool,
    isNewQuote: PropTypes.bool,
    onLeadTimeOverridden: PropTypes.func.isRequired,
    onLeadTimeRemoved: PropTypes.func.isRequired,
    eligibleForFastTrack: PropTypes.func.isRequired,
    isLuggingOnlyFastTrack: PropTypes.func.isRequired
  };

  showLeadTimeOverride(item, isChange) {
    this.leadTimeOverrideModal.current.showModal(item, isChange);
  }

  async removeLeadTimeOverride(item) {
    const { quoteProduct } = this.props;
    const productId = quoteProduct.leadTime.product.correlationId;
    const state = quoteProduct.leadTime.state;
    const leadTimeOutput = await LeadTimeOverrideCalculationService.removeOverrideLeadTime({ productId: productId, state: state, key: item.key });

    this.props.onLeadTimeRemoved(item, leadTimeOutput);
    this.forceUpdate();
  }

  overrideLeadTime = (item, leadTimeOutput) => {
    this.props.onLeadTimeOverridden(item, leadTimeOutput);
    this.forceUpdate();
  };

  render() {
    const { name, isOverrideMode, leadTimeItem, eligibleForFastTrack, isLuggingOnlyFastTrack } = this.props;

    if (!leadTimeItem) {
      return null;
    }
    return (
      <Fragment>
        <ul className="list-unstyled">
          <li className="mb-2">
            <span className="me-2 text-lg">
              <strong>{name}</strong>
            </span>
          </li>
          {leadTimeItem.subComponents.map((subItem, idx) => {
            const isOverridden = subItem.isOverridden || !!subItem.overrideValue;

            if (eligibleForFastTrack && (subItem.key === 'EngineeringQueueTime' || subItem.key === 'EngineeringLeadTime') && !isLuggingOnlyFastTrack) {
              return ('');
            }

            return (
              <li className="mb-2" key={idx}>
                <strong>{subItem.name}</strong>
                <div className='row ms-4'>
                  <LeadTimeLabel leadTime={subItem} />
                </div>
                {isOverrideMode && !isOverridden && isAmiUserAuthorizedToOverrideQuoteLeadTimes() &&
                  <div className='row ms-4'>
                    <button className="btn btn-link pt-1 ps-0 m-0" type="button" onClick={() => this.showLeadTimeOverride(subItem, false)}>override</button>
                  </div>
                }
                {isOverrideMode && isOverridden && isAmiUserAuthorizedToOverrideQuoteLeadTimes() &&
                  <div>
                    <span className="badge text-bg-warning pt-1 me-2">overridden</span>
                    <button className="btn btn-link pt-1 pe-2 m-0" type="button" onClick={() => this.showLeadTimeOverride(subItem, true)}>change</button>
                    <button className="btn btn-link pt-1 ps-2 m-0" type="button" onClick={() => this.removeLeadTimeOverride(subItem)}>remove</button>
                  </div>
                }
              </li>
            )
          })}
          {
            leadTimeItem.details?.length > 0 &&
            <div className="hr-divider inverse mb-2">
              <h4 className="hr-divider-content hr-divider-heading">
                <button className='btn btn-link' onClick={() => {
                  leadTimeItem.showDetails = !leadTimeItem.showDetails;
                  this.forceUpdate();
                }}>{leadTimeItem.showDetails === true ? '-' : '+'} Details</button>
              </h4>
            </div>
          }

          {leadTimeItem.showDetails && leadTimeItem.details.map((item, idx) => {
            return (
              <li className="mb-2" key={idx}>
                <label>{item}</label>
              </li>
            )
          })}
        </ul>

        <LeadTimeOverrideModal
          ref={this.leadTimeOverrideModal}
          quoteId={this.props.quoteId}
          quoteProduct={this.props.quoteProduct}
          onLeadTimeOverridden={this.overrideLeadTime}
        />

      </Fragment>
    )
  }
}
